// What a feed card offers at the end of its footer. The home feed offers the
// ways to remix a seed; the jam picker (/jam/start) is the same feed with one
// way in, "Start Jam". A context rather than a prop: the card sits under
// CardList, which every list of seeds shares.

import { createContext, useContext } from "react";

export type FeedCta = "remix" | "jam";

export const FeedCtaContext = createContext<FeedCta>("remix");

export function useFeedCta(): FeedCta {
  return useContext(FeedCtaContext);
}
